import React, { useContext } from "react";
import { Row, Col, FormGroup, FormControl, FormLabel, Form } from "react-bootstrap";
import { useWizard } from "./WizardContext";
import Select from "react-select";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import SweetAlert from "react-bootstrap-sweetalert";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
import cuteVege1 from "../../../../assets/img/baolinPrivate/cute_vege1.png";
import cuteVege2 from "../../../../assets/img/baolinPrivate/cute_vege2.png";
import lunarLampRight from "../../../../assets/img/baolinPrivate/lunarLampRight.png";
import lunarLampLeft from "../../../../assets/img/baolinPrivate/lunarLampLeft.png";
const Step2 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
    event1, setEvent1,
    event2, setEvent2,
    headcountEvent1, setHeadcountEvent1,
    headcountEvent2, setHeadcountEvent2,
    timeslot, setTimeslot

  } = useWizard();

  const { language } = useGuestContext();

  //define error messages
  const [firstnameError, setFirstnameError] = React.useState(null);
  const [lastnameError, setLastnameError] = React.useState(null);
  const [emailError, setEmailError] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(null);
  const [chinesenameError, setChinesenameError] = React.useState(null);
  const [timeslotError, setTimeslotError] = React.useState(null);
  const [headcountEvent1Error, setHeadcountEvent1Error] = React.useState(null);
  const [headcountEvent2Error, setHeadcountEvent2Error] = React.useState(null);
  const [eventSelectionError, setEventSelectionError] = React.useState(null);

  //state for warning alert
  const [alertState, setAlertState] = React.useState(null);

  const handleCheckboxChange = (event, setSession) => {
    setSession(event.target.checked);
  };

  const handleHeadcountEvent1Change = (option) => {
    setHeadcountEvent1(option.value);
    // Clear any existing error when user selects a value
    setHeadcountEvent1Error(null);
    // Show warning alert when user selects a number
    setAlertState(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={language === "English" ? "Reminder" : "提醒"}
        onConfirm={() => setAlertState(null)}
        confirmBtnBsStyle="success"
        confirmBtnText={language === "English" ? "I Understand" : "我明白了"}
      >
        <strong>
          {language === "English"
            ? "Please make sure the total size of your group should also include yourself."
            : "参加总人数也包括您自己本人"
          }
        </strong>
      </SweetAlert>
    );
  };

  const handleHeadcountEvent2Change = (option) => {
    setHeadcountEvent2(option.value);
    // Clear any existing error when user selects a value
    setHeadcountEvent2Error(null);
    // Show warning alert when user selects a number
    setAlertState(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={language === "English" ? "Reminder" : "提醒"}
        onConfirm={() => setAlertState(null)}
        confirmBtnBsStyle="success"
        confirmBtnText={language === "English" ? "I Understand" : "我明白了"}
      >
        <strong>
          {language === "English"
            ? "Please make sure the total size of your group should also include yourself."
            : "参加总人数也包括您自己本人"
          }
        </strong>
      </SweetAlert>
    );
  };

  const handleNameChange = (value, setName, setError, isChineseName = false) => {
    // Regular expression for non-Chinese names: allows letters, spaces, hyphens, and apostrophes
    const nameRegex = /^[A-Za-z\s'-]+$/;
    // Regular expression for Chinese names: allows Chinese characters (including simplified and traditional), spaces, and common name characters
    const chineseNameRegex = /^[\u4e00-\u9fa5\s·]+$/;

    let isValid = isChineseName ? chineseNameRegex.test(value) : nameRegex.test(value);

    if (!isValid && value !== "") {
      setError(
        <small className="text-danger">
          {language === "English"
            ? isChineseName
              ? "Invalid characters. Only Chinese characters are allowed."
              : "Invalid characters. Only letters, spaces, hyphens, and apostrophes are allowed."
            : isChineseName
              ? "包含无效字符。只允许中文字符。"
              : "包含无效字符。只允许字母、空格、连字符和撇号。"
          }
        </small>
      );
    } else {
      setError(null);
    }
    setName(value);
  };
  const isValidated = () => {
    console.log("hey");
    // var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // re.test(email) === false
    //   ? setEmailError(
    //     <small className="text-danger">
    //       {language === "English" ? "Invalid email format. A correct format looks like john@doe.com." : "電子郵件格式不正確  正確格式類似於john@doe.com."}
    //     </small>
    //   )
    //   : setEmailError(null);
    //check firstname
    (firstname === null || firstname.trim() === "")
      ? setFirstnameError(
        <small className="text-danger">{language === "English" ? "First name is required." : "未填寫英文名"}</small>
      )
      : setFirstnameError(null);

    //check lastname
    (lastname === null || lastname.trim() === "")
      ? setLastnameError(
        <small className="text-danger">{language === "English" ? "Last name is required." : "未填寫英文姓"}</small>
      )
      : setLastnameError(null);

    (phone === null || phone.trim() === "")
      ? setPhoneError(
        <small className="text-danger">{language === "English" ? "Please enter a contact phone number." : "請填息聯繫電話以方便聯絡."}</small>
      )
      : setPhoneError(null);

    //check event selection (at least one event must be selected)
    (!event1 && !event2)
      ? setEventSelectionError(
        <small className="text-danger">{language === "English" ? "Please select at least one event." : "請至少選擇一個法會"}</small>
      )
      : setEventSelectionError(null);

    //check headcountEvent1 (group size) - only if event1 is selected
    if (event1) {
      (headcountEvent1 === null || headcountEvent1 === undefined)
        ? setHeadcountEvent1Error(
          <small className="text-danger">{language === "English" ? "Please select group size for Chinese Year-End blessing Ceremony." : "請選擇歲末祈福法會的隨行人數"}</small>
        )
        : setHeadcountEvent1Error(null);
    } else {
      setHeadcountEvent1Error(null);
    }

    //check headcountEvent2 (group size) - only if event2 is selected
    if (event2) {
      (headcountEvent2 === null || headcountEvent2 === undefined)
        ? setHeadcountEvent2Error(
          <small className="text-danger">{language === "English" ? "Please select group size for Lunar New Year's Homage ceremony." : "請選擇新春合禮團拜法會的隨行人數"}</small>
        )
        : setHeadcountEvent2Error(null);
    } else {
      setHeadcountEvent2Error(null);
    }

    // var gd = gender !== null;
    // var em = re.test(email) === true;
    var fn = !(firstname === null || firstname.trim() === "");
    var ln = !(lastname === null || lastname.trim() === "");
    var ph = !(phone === null || phone.trim() === "");
    var ev = event1 || event2; // at least one event must be selected
    var hc1 = !event1 || !(headcountEvent1 === null || headcountEvent1 === undefined); // headcountEvent1 required only if event1 is selected
    var hc2 = !event2 || !(headcountEvent2 === null || headcountEvent2 === undefined); // headcountEvent2 required only if event2 is selected
    var valid = fn && ln && ph && ev && hc1 && hc2;
    return valid;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));


  const headcountEvent1Options = Array.from({ length: 15 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));

  const headcountEvent2Options = Array.from({ length: 15 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));

  return (
    <>
      {alertState}
      <div className="wizard-step" ref={ref}>
        <p className="text-center mb-2 font-weight-bold">
          <img src={lunarLampLeft} alt="Company Logo" width="40" className="mr-3" />
          {language === "English" ? "Event Information" : "請提供以下法會相關信息"}
          <img src={lunarLampRight} alt="Company Logo" width="40" className="ml-3" />
        </p>
        <hr />
        <LanguageToggle />
        <hr />

        <Row>
          <Col md={{ span: 7, offset: 1 }}>
          <FormGroup>
              <FormLabel>
                {language === "English" ? "Which event would you like to attend?" : "請選擇要參加的新年法會"} <span className="text-danger">*</span>
              </FormLabel>
              <Row>
                <Form.Check className="checkbox-inline">
                  <Form.Check.Label>
                    <Form.Check.Input
                      defaultValue="event1"
                      type="checkbox"
                      checked={event1 || false}
                      onChange={(e) => {
                        handleCheckboxChange(e, setEvent1);
                        if (!e.target.checked) {
                          // Clear headcount when event is unchecked
                          setHeadcountEvent1(null);
                          setHeadcountEvent1Error(null);
                        }
                        if (e.target.checked || event2) {
                          setEventSelectionError(null);
                        }
                      }}
                    ></Form.Check.Input>
                    <span className="form-check-sign"></span>
                    {language === "English" 
                      ? "Chinese Year-End blessing Ceremony"
                      : "歲末祈福法會"}
                  </Form.Check.Label>
                </Form.Check>
                <Form.Check className="checkbox-inline">
                  <Form.Check.Label>
                    <Form.Check.Input
                      defaultValue="event2"
                      type="checkbox"
                      checked={event2 || false}
                      onChange={(e) => {
                        handleCheckboxChange(e, setEvent2);
                        if (!e.target.checked) {
                          // Clear headcount when event is unchecked
                          setHeadcountEvent2(null);
                          setHeadcountEvent2Error(null);
                        }
                        if (e.target.checked || event1) {
                          setEventSelectionError(null);
                        }
                      }}
                    ></Form.Check.Input>
                    <span className="form-check-sign"></span>
                    {language === "English"
                      ? "Lunar New Year's Homage to the buddhas and great Patriarchs ceremony"
                      : "新春合禮團拜法會"}
                  </Form.Check.Label>
                </Form.Check>
              </Row>
              {eventSelectionError}
            </FormGroup>
          </Col>
        </Row>
        {event1 && (
          <Row>
            <Col md={{ span: 7, offset: 1 }}>
              <FormGroup>
                <FormLabel>
                  {language === "English" 
                    ? "Group Size for Chinese Year-End blessing Ceremony (People Coming Along and yourself)" 
                    : "歲末祈福法會参加人数（包括自己）"} <span className="text-danger">*</span>
                </FormLabel>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="headcountEvent1Select"
                  value={headcountEvent1Options.find((option) => option.value === headcountEvent1)}
                  onChange={handleHeadcountEvent1Change}
                  options={headcountEvent1Options}
                  placeholder={language === "English" ? "Select number" : "选择人数"}
                />
                {headcountEvent1Error}
              </FormGroup>
            </Col>
          </Row>
        )}
        {event2 && (
          <Row>
            <Col md={{ span: 7, offset: 1 }}>
              <FormGroup>
                <FormLabel>
                  {language === "English" 
                    ? "Group Size for Lunar New Year's Homage ceremony (People Coming Along and yourself)" 
                    : "新春合禮團拜法會参加人数（包括自己）"} <span className="text-danger">*</span>
                </FormLabel>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="headcountEvent2Select"
                  value={headcountEvent2Options.find((option) => option.value === headcountEvent2)}
                  onChange={handleHeadcountEvent2Change}
                  options={headcountEvent2Options}
                  placeholder={language === "English" ? "Select number" : "选择人数"}
                />
                {headcountEvent2Error}
              </FormGroup>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
});

export default Step2;
